var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"error"}},[_vm._v("Sorry, you are not authorized to view the requested page.")])}
var staticRenderFns = []

export { render, staticRenderFns }